    <div>
        <span>Replying to: </span> {{PostUsername}}
    </div>

    <textarea class="form-control" style="font-size: 1.5rem;" placeholder="Post your reply" [(ngModel)]="UserPostsDataContent.PostContent" rows="1" (keyup)="adjustTextareaHeight($event)"></textarea>

    <!-- Container for single and double images -->
    <div *ngIf="mediaUrls.length === 1">
        <div class="image-container-one">
            <div class="media-item">
                <div *ngIf="mediaUrls[0].isVideo; else imageTemplate" class="video-container">
                    <video controls class="img-fluid" style="width: 100%; height: auto; object-fit: cover;" [src]="mediaUrls[0].url">
                        Your browser does not support the video tag.
                    </video>
                </div>
                <ng-template #imageTemplate>
                    <img [src]="!mediaUrls[0].isTenor ? mediaUrls[0].url : (mediaUrls[0].isPlaying ? mediaUrls[0].animatedUrl : mediaUrls[0].previewUrl)"
                         class="img-fluid" style="width: 100%; height: auto; object-fit: cover;" (click)="togglePlay(0)">
                </ng-template>
                <div class="overlay-controls" (click)="togglePlay(0)">
                    <button class="btn position-absolute top-right" (click)="removeMediaAtIndex(0)">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="103.7934 76.2505 48.4703 47.1893" width="30px" height="30px">
                            <circle cx="13.346" cy="13.768" fill="#333333" opacity="0.1" r="30" style="" transform="matrix(0.807839035987854, 0, 0, 0.7864879369735718, 117.24717843532562, 89.01677533984184)" />
                            <path d="M10.59 12L4.54 5.96l1.42-1.42L12 10.59l6.04-6.05 1.42 1.42L13.41 12l6.05 6.04-1.42 1.42L12 13.41l-6.04 6.05-1.42-1.42L10.59 12z" transform="matrix(1, 0, 0, 1, 116.04206848144531, 89.35821533203125)" />
                        </svg>
                    </button>
                    <!-- Toggle Play/Pause if the URL is from Tenor -->
                    <button *ngIf="mediaUrls[0].isTenor && !mediaUrls[0].isPlaying" class="btn play-btn position-absolute center">
                        <svg viewBox="0 0 60 61" aria-hidden="true" class="play-icon">
                            <g>
                                <circle cx="30" cy="30.4219" fill="#333333" opacity="0.3" r="30"></circle>
                                <path d="M22.2275 17.1971V43.6465L43.0304 30.4218L22.2275 17.1971Z" fill="white"></path>
                            </g>
                        </svg>
                    </button>
                    <!-- No visual indicator for pause; clicking the image itself toggles play/pause -->
                    <button *ngIf="mediaUrls[0].isTenor && mediaUrls[0].isPlaying" class="btn play-btn position-absolute center">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="106.8031 109.2966 416 416" width="50px" height="50px">
                            <g transform="matrix(1, 0, 0, 1, 58.80305480957031, 61.29664230346679)">
                                <path d="M256,48C141.31,48,48,141.31,48,256s93.31,208,208,208,208-93.31,208-208S370.69,48,256,48ZM224,320a16,16,0,0,1-32,0V192a16,16,0,0,1,32,0Zm96,0a16,16,0,0,1-32,0V192a16,16,0,0,1,32,0Z" style="fill:#333333; opacity:0.1" />
                            </g>
                        </svg>
                    </button>
                </div>
            </div>
            <p class="caption" *ngIf="mediaUrls[0].isTenor">via <a href="https://tenor.com">TENOR</a></p>
        </div>
    </div>

    <!-- Carousel for two or more images -->
    <div *ngIf="mediaUrls.length > 1" class="carousel-container position-relative">
        <p-carousel [value]="mediaUrls" numVisible="2" numScroll="1" [circular]="true" [responsiveOptions]="responsiveOptions"
                    [ngClass]="{'left': isAtStart, 'right': isAtEnd}" (onPage)="updateActiveIndex($event)">
            <ng-template let-item pTemplate="item">
                <div class="carousel-item-wrapper">
                    <div class="image-container">
                        <div *ngIf="item.isVideo; else imageTemplate" class="video-container">
                            <video controls class="img-fluid" [src]="item.url">
                                Your browser does not support the video tag.
                            </video>
                        </div>
                        <ng-template #imageTemplate>
                            <img [src]="item.isTenor ? (item.isPlaying ? item.animatedUrl : item.previewUrl) : item.url" class="img-fluid" alt="Dynamic image" (click)="togglePlay(item.index)">
                        </ng-template>
                        <div class="overlay-controls" (click)="togglePlay(item.index)">
                            <button class="btn position-absolute top-right" (click)="removeMediaAtIndex(item.index)">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="103.7934 76.2505 48.4703 47.1893" width="30px" height="30px">
                                    <circle cx="13.346" cy="13.768" fill="#333333" opacity="0.1" r="30" style="" transform="matrix(0.807839035987854, 0, 0, 0.7864879369735718, 117.24717843532562, 89.01677533984184)" />
                                    <path d="M10.59 12L4.54 5.96l1.42-1.42L12 10.59l6.04-6.05 1.42 1.42L13.41 12l6.05 6.04-1.42 1.42L12 13.41l-6.04 6.05-1.42-1.42L10.59 12z" transform="matrix(1, 0, 0, 1, 116.04206848144531, 89.35821533203125)" />
                                </svg>
                            </button>
                            <button *ngIf="item.isTenor && !item.isPlaying" class="btn play-btn position-absolute center">
                                <svg viewBox="0 0 60 61" aria-hidden="true" class="play-icon">
                                    <g>
                                        <circle cx="30" cy="30.4219" fill="#333333" opacity="0.3" r="30"></circle>
                                        <path d="M22.2275 17.1971V43.6465L43.0304 30.4218L22.2275 17.1971Z" fill="white"></path>
                                    </g>
                                </svg>
                            </button>
                            <!-- No visual indicator for pause; clicking the image itself toggles play/pause -->
                            <button *ngIf="item.isTenor && item.isPlaying" class="btn play-btn position-absolute center">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="106.8031 109.2966 416 416" width="50px" height="50px">
                                    <g transform="matrix(1, 0, 0, 1, 58.80305480957031, 61.29664230346679)">
                                        <path d="M256,48C141.31,48,48,141.31,48,256s93.31,208,208,208,208-93.31,208-208S370.69,48,256,48ZM224,320a16,16,0,0,1-32,0V192a16,16,0,0,1,32,0Zm96,0a16,16,0,0,1-32,0V192a16,16,0,0,1,32,0Z" style="fill:#333333; opacity:0.1" />
                                    </g>
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
                <p *ngIf="item.isTenor" class="caption">via <a href="https://tenor.com">TENOR</a></p>
            </ng-template>
        </p-carousel>
    </div>

    <!-- Reply Dropdown -->
    <div class="ps-3 d-flex text-info">
        <div class="dropdown">
            <button class="btn dropdown-toggle" type="button" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style="padding-right: 30px; margin-right:10px;">
                {{ selectedReplyType.text }} can reply
            </button>
            <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                <h6 class="dropdown-header">Who can reply?</h6>
                <p class="dropdown-header small">Choose who can reply to this post. Anyone mentioned can always reply.</p>
                <a class="dropdown-item d-flex align-items-center" href="#" *ngFor="let type of replyTypes" (click)="setReplyType(type)">
                    <img [src]="type.icon" class="me-2" [alt]="type.text"> {{ type.text }}
                    <span *ngIf="selectedReplyType.id === type.id" class="ms-auto">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check" viewBox="0 0 16 16">
                            <path d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.07-1.05l2.073 2.384 3.505-4.746z" />
                        </svg>
                    </span>
                </a>
            </div>
        </div>
    </div>

    <!-- Image Upload Hidden Input -->
    <div class="row pb-2 justify-content-center">
        <div class="col-9 text-info">
            <!-- Hidden file input for uploading videos -->
            <input type="file" id="videoUpload" (change)="checkVideo($event)" accept="video/*,image/jpeg,image/png,image/gif" style="display: none;">
            <span class="ps-3" *ngIf="mediaUrls.length < 4" (click)="triggerFileUpload()">
                <span style="display: inline-block; ">
                    <svg *ngIf="mediaUrls.length < 4" (click)="triggerFileUpload(); $event.stopPropagation();"
                         xmlns="http://www.w3.org/2000/svg"
                         viewBox="0 0 283 283"
                         width="18"
                         height="18">
                        <path style="fill: rgb(135, 135, 135);" d="m149.823,258.142c-31.398,30.698 -81.882,30.576 -113.105,-0.429c-31.214,-30.987 -31.337,-81.129 -0.42,-112.308l-0.026,-0.018l113.569,-112.772l14.203,-14.098c23.522,-23.356 61.65,-23.356 85.172,0s23.522,61.221 0,84.586l-125.19,123.02l-0.044,-0.035c-15.428,14.771 -40.018,14.666 -55.262,-0.394c-15.244,-15.069 -15.34,-39.361 -0.394,-54.588l-0.044,-0.053l13.94,-13.756l69.701,-68.843l13.931,13.774l-83.632,82.599c-7.701,7.596 -7.701,19.926 0,27.53s20.188,7.604 27.88,0l124.918,-123.37l-0.035,-0.026l0.473,-0.403c15.682,-15.568 15.682,-40.823 0,-56.39s-41.094,-15.568 -56.776,0l-0.42,0.473l-0.026,-0.018l-14.194,14.089l-113.576,112.773c-23.522,23.356 -23.522,61.221 0,84.577s61.659,23.356 85.163,0l99.375,-98.675l14.194,-14.089l14.194,14.089l-14.194,14.098l-99.357,98.675c0,-0.001 -0.018,-0.018 -0.018,-0.018z" />
                    </svg>
                </span>
            </span>
            <span class="ps-3" *ngIf="mediaUrls.length < 4" (click)="openGifModal()">
                <svg viewBox="0 0 24 24" width="24" height="24" aria-hidden="true" class="r-4qtqp9 r-yyyyoo r-dnmrzs r-bnwqim r-lrvibr r-m6rgpd r-z80fyv r-19wmn03" style="color: rgb(135, 135, 135);">
                    <g>
                        <path style="fill: rgb(135, 135, 135);" d="M3 5.5C3 4.119 4.12 3 5.5 3h13C19.88 3 21 4.119 21 5.5v13c0 1.381-1.12 2.5-2.5 2.5h-13C4.12 21 3 19.881 3 18.5v-13zM5.5 5c-.28 0-.5.224-.5.5v13c0 .276.22.5.5.5h13c.28 0 .5-.224.5-.5v-13c0-.276-.22-.5-.5-.5h-13zM18 10.711V9.25h-3.74v5.5h1.44v-1.719h1.7V11.57h-1.7v-.859H18zM11.79 9.25h1.44v5.5h-1.44v-5.5zm-3.07 1.375c.34 0 .77.172 1.02.43l1.03-.86c-.51-.601-1.28-.945-2.05-.945C7.19 9.25 6 10.453 6 12s1.19 2.75 2.72 2.75c.85 0 1.54-.344 2.05-.945v-2.149H8.38v1.032H9.4v.515c-.17.086-.42.172-.68.172-.76 0-1.36-.602-1.36-1.375 0-.688.6-1.375 1.36-1.375z">
                        </path>
                    </g>
                </svg>

            </span>
            <span class="ps-3"><i class="fa fa-face-grin"></i></span>
            <span class="ps-3"><i class="fa fa-location-pin"></i></span>
        </div>
        <div class="col-3 col-sm-2  ">
            <button class="text-decoration-none fs-6  fw-bold text-white bg-gray py-1 px-3  rounded-pill"
                    [disabled]="!UserPostsDataContent.PostContent" (click)="saveReply()">
                Reply
            </button>
        </div>
    </div>
